import qs from 'query-string';
import history from '../history';

// The check-in app can be opened with ?access_token= in the query string (kiosk mode).
// The token must leave the address bar before Sentry.init runs: Replay records the page
// URL as loaded (replay urls list, first snapshot href, navigation timing entry) and none
// of that goes through beforeSend. app.js calls captureAccessTokenFromUrl() first thing;
// AuthorizedRoute then reads the stashed value with consumeAccessTokenQS().
const STASH_KEY = '__ACCESS_TOKEN_QS__';

export const captureAccessTokenFromUrl = () => {
    const { pathname, search, hash, state } = history.location;
    const query = qs.parse(search, { ignoreQueryPrefix: true });
    const { access_token: accessToken, ...rest } = query;
    if (!accessToken) return null;
    const cleaned = qs.stringify(rest);
    history.replace({ pathname, search: cleaned ? `?${cleaned}` : '', hash, state });
    window[STASH_KEY] = accessToken;
    return accessToken;
};

export const consumeAccessTokenQS = () => {
    const accessToken = captureAccessTokenFromUrl() || window[STASH_KEY] || null;
    delete window[STASH_KEY];
    return accessToken;
};
